import { Form, Formik } from "formik";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { useSelector } from "react-redux";
import jssVariables from "../../../jss_setup";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { InputField } from "../../forms/inputGroup";
import { AirportAutoCompleteField } from "../../forms/inputGroup/helpers";

const autoCompleteStyles = {
  label: {
    fontSize: "medium",
    fontWeight: 400,
  },
  control: {
    borderColor: jssVariables.colors.border,
  },
};

const inputFieldStyles = {
  label: {
    fontSize: "medium",
    fontWeight: 400,
  },
};

const travellersFormsStyles = createUseStyles({
  FlightsForm: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    overflow: "auto",
    height: "max-content",
    color: jssVariables.colors.text.dark,
    ..._.get(props, "customStyles.FlightsForm", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.form", {}),
  }),
  subTitle: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.subTitle", {}),
  }),
  row2: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    fontSize: "small",
    fontWeight: "bold",
    ..._.get(props, "customStyles.row2", {}),
  }),
  guestHeader: (props) => ({
    fontSize: "large",
    fontWeight: "bold",
    ..._.get(props, "customStyles.guestHeader", {}),
  }),
  divider: (props) => ({
    height: `calc(${jssVariables.normal_gap} / 4)`,
    width: "100%",
    background: "lightgray",
    marginTop: jssVariables.normal_gap,
    ..._.get(props, "customStyles.divider", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    FlightsForm: (props) => ({
      gridAutoFlow: "unset",
      maxHeight: "70vh",
      ..._.get(props, "customStyles.FlightsForm.smallscreen", {}),
    }),
    form: (props) => ({
      display: "grid",
      gridGap: jssVariables.normal_gap,
      gridTemplateColumns: props.pax > 1 ? "1fr 1fr" : "1fr",
      ..._.get(props, "customStyles.form.smallscreen", {}),
    }),
    row2: (props) => ({
      gridTemplateColumns: "1fr 1fr",
      ..._.get(props, "customStyles.row2.smallscreen", {}),
    }),
    divider: (props) => ({
      ..._.get(props, "customStyles.divider.smallscreen", {}),
    }),
  },
});
const FlightsForm = ({ flightsDtls, setFlightsDtls }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "TrfFlightsForm",
  });
  const classes = travellersFormsStyles({ customStyles });
  const { t } = useContext(TranslationContext);

  const { tripMode } = useSelector((state) => {
    return {
      tripMode: _.get(state.TransfersSearchForm, "tripMode", ""),
    };
  });

  return (
    <div className={classes.FlightsForm}>
      <Formik
        initialValues={flightsDtls}
        validateOnMount={false}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          setFlightsDtls(values);
        }}>
        <Form className={classes.form}>
          {tripMode !== "poi_to_air" && (
            <React.Fragment>
              <span className={classes.subTitle}>{t("inboundJourney")}</span>
              <AirportAutoCompleteField
                id="inboundTrfAirport"
                name="inbound"
                label={t("airportYouAreFlyingFrom")}
                defaultValue={_.get(flightsDtls, "inbound.inbound_meta.0", {})}
                customStyles={{
                  ...autoCompleteStyles,
                  ..._.get(customStyles, "inputGroupField", {}),
                }}
                withErrors={false}
              />
              <div className={classes.row2}>
                <InputField
                  id="inboundFlightNumber"
                  name="inboundFlightNumber"
                  label={t("inboundFlightNumber")}
                  customStyles={{
                    ...inputFieldStyles,
                    ..._.get(customStyles, "inputGroupField", {}),
                  }}
                />
                <InputField
                  id="inboundAirlineName"
                  name="inboundAirlineName"
                  label={t("inboundAirlineName")}
                  customStyles={{
                    ...inputFieldStyles,
                    ..._.get(customStyles, "inputGroupField", {}),
                  }}
                />
              </div>
            </React.Fragment>
          )}
          {tripMode === "round_trip" && <div className={classes.divider} />}
          {tripMode !== "air_to_poi" && (
            <React.Fragment>
              <span className={classes.subTitle}>{t("outboundJourney")}</span>
              <AirportAutoCompleteField
                name="outbound"
                label={t("airportYouAreFlyingTo")}
                defaultValue={_.get(
                  flightsDtls,
                  "outbound.outbound_meta.0",
                  {}
                )}
                customStyles={autoCompleteStyles}
                withErrors={false}
              />
              <div className={classes.row2}>
                <InputField
                  name="outboundFlightNumber"
                  label={t("outboundFlightNumber")}
                  customStyles={inputFieldStyles}
                />
                <InputField
                  name="outboundAirlineName"
                  label={t("outboundAirlineName")}
                  customStyles={inputFieldStyles}
                />
              </div>
            </React.Fragment>
          )}
        </Form>
      </Formik>
    </div>
  );
};
FlightsForm.defaultProps = {
  flightsDtls: {},
};
FlightsForm.propTypes = {
  flightsDtls: PropTypes.object.isRequired,
  setFlightsDtls: PropTypes.func.isRequired,
};
export default FlightsForm;
